import { useState } from 'react';
import { SystemCaptionsModule } from '@components';
import { useRecoilState } from 'recoil';

import { userSettingsState } from '@store';

import { isAndroid } from '../helpers/Platform';

export const useGetDeviceCaptionsSettings = () => {
  const [hasSetSystemSetting, setHasSetSystemSetting] = useState(false);
  const [userSettings, setUserSettings] = useRecoilState(userSettingsState);

  if (isAndroid) {
    SystemCaptionsModule?.getSystemCaptionsSetting(captionsEnabled => {
      if (!hasSetSystemSetting) {
        const newSettings = { ...userSettings };

        newSettings.closeCaptionEnabled = captionsEnabled;
        setUserSettings(newSettings);
        setHasSetSystemSetting(true);
      }
    });
  }

  return userSettings.closeCaptionEnabled;
};
